import { render, staticRenderFns } from "./ornament.vue?vue&type=template&id=bc0def4c&"
import script from "./ornament.vue?vue&type=script&lang=js&"
export * from "./ornament.vue?vue&type=script&lang=js&"
import style0 from "./ornament.vue?vue&type=style&index=0&id=bc0def4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports